import React, { useEffect } from "react";
import { Select } from "antd";

import { useConfig } from "../../../data/useConfig";
import { useSearchResults } from "../../../data/useSearchResults";
import { SORT_PARAM_KEY } from "../../../utils/constants";

const { Option } = Select;

const DEFAULT_SORT_OPTIONS = [
  { key: "relevance", name: "relevancia", label: "Relevância" },
  { key: "bestSellers", name: "populares", label: "Mais populares" },
  { key: "newest", name: "novidades", label: "Novidades" },
  { key: "priceLow", name: "menor_preco", label: "Menor preço" },
  { key: "priceHigh", name: "maior_preco", label: "Maior preço" },
  { key: "discountHigh", name: "desconto", label: "Desconto" },
];

const SortOptions = () => {
  const { sortConfigs, sortOptions } = useConfig();
  const { sortKey, setSortKey, updatePathQuery } = useSearchResults();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const urlSortKey = urlParams.get(SORT_PARAM_KEY);

  const availableSortOptions = DEFAULT_SORT_OPTIONS.filter(
    ({ key }) => sortConfigs[key]?.available
  );

  const defaultValue =
    urlSortKey ||
    sortConfigs?.default ||
    availableSortOptions?.[0].name ||
    sortKey;

  const handleChangeOrder = (value) => {
    updatePathQuery({ sortKey: value });
    setSortKey(value);
  };

  useEffect(() => {
    if (!sortKey) {
      setSortKey(sortConfigs?.default || availableSortOptions?.[0].name);
    }
  }, [availableSortOptions, setSortKey, sortConfigs, sortKey]);

  return (
    <Select
      value={sortKey}
      defaultValue={defaultValue}
      style={{ width: 250 }}
      onChange={handleChangeOrder}
    >
      {(sortOptions || availableSortOptions)?.map((item, i) => (
        <Option key={item.key || `sortOption-${i}`} value={item.name}>
          {item.label}
        </Option>
      ))}
    </Select>
  );
};

export default SortOptions;
